import { defineComponent as q, computed as g, h as l } from "vue";
import { useRtl as G } from "./ghl-ui.es851.js";
import J from "./ghl-ui.es922.js";
import Q from "./ghl-ui.es854.js";
import b from "./ghl-ui.es855.js";
import { createKey as h } from "./ghl-ui.es384.js";
import { getMargin as U } from "./ghl-ui.es856.js";
import { useThemeClass as X } from "./ghl-ui.es857.js";
import { resolveWrappedSlot as n } from "./ghl-ui.es860.js";
import { call as Y } from "./ghl-ui.es876.js";
import Z from "./ghl-ui.es923.js";
import ee from "./ghl-ui.es859.js";
import { keysOf as oe } from "./ghl-ui.es924.js";
const p = {
  title: String,
  contentClass: String,
  contentStyle: [Object, String],
  headerClass: String,
  headerStyle: [Object, String],
  headerExtraClass: String,
  headerExtraStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  embedded: Boolean,
  segmented: {
    type: [Boolean, Object],
    default: !1
  },
  size: {
    type: String,
    default: "medium"
  },
  bordered: {
    type: Boolean,
    default: !0
  },
  closable: Boolean,
  hoverable: Boolean,
  role: String,
  onClose: [Function, Array],
  tag: {
    type: String,
    default: "div"
  }
}, pe = oe(p), te = Object.assign(Object.assign({}, b.props), p), Ce = q({
  name: "Card",
  props: te,
  setup(t) {
    const i = () => {
      const {
        onClose: o
      } = t;
      o && Y(o);
    }, {
      inlineThemeDisabled: d,
      mergedClsPrefixRef: e,
      mergedRtlRef: m
    } = Q(t), s = b("Card", "-card", J, Z, t, e), f = G("Card", m, e), a = g(() => {
      const {
        size: o
      } = t, {
        self: {
          color: c,
          colorModal: C,
          colorTarget: u,
          textColor: v,
          titleTextColor: S,
          titleFontWeight: y,
          borderColor: $,
          actionColor: x,
          borderRadius: z,
          lineHeight: R,
          closeIconColor: _,
          closeIconColorHover: B,
          closeIconColorPressed: E,
          closeColorHover: P,
          closeColorPressed: O,
          closeBorderRadius: j,
          closeIconSize: T,
          closeSize: I,
          boxShadow: k,
          colorPopover: F,
          colorEmbedded: H,
          colorEmbeddedModal: w,
          colorEmbeddedPopover: M,
          [h("padding", o)]: V,
          [h("fontSize", o)]: K,
          [h("titleFontSize", o)]: L
        },
        common: {
          cubicBezierEaseInOut: N
        }
      } = s.value, {
        top: W,
        left: A,
        bottom: D
      } = U(V);
      return {
        "--n-bezier": N,
        "--n-border-radius": z,
        "--n-color": c,
        "--n-color-modal": C,
        "--n-color-popover": F,
        "--n-color-embedded": H,
        "--n-color-embedded-modal": w,
        "--n-color-embedded-popover": M,
        "--n-color-target": u,
        "--n-text-color": v,
        "--n-line-height": R,
        "--n-action-color": x,
        "--n-title-text-color": S,
        "--n-title-font-weight": y,
        "--n-close-icon-color": _,
        "--n-close-icon-color-hover": B,
        "--n-close-icon-color-pressed": E,
        "--n-close-color-hover": P,
        "--n-close-color-pressed": O,
        "--n-border-color": $,
        "--n-box-shadow": k,
        // size
        "--n-padding-top": W,
        "--n-padding-bottom": D,
        "--n-padding-left": A,
        "--n-font-size": K,
        "--n-title-font-size": L,
        "--n-close-size": I,
        "--n-close-icon-size": T,
        "--n-close-border-radius": j
      };
    }), r = d ? X("card", g(() => t.size[0]), a, t) : void 0;
    return {
      rtlEnabled: f,
      mergedClsPrefix: e,
      mergedTheme: s,
      handleCloseClick: i,
      cssVars: d ? void 0 : a,
      themeClass: r == null ? void 0 : r.themeClass,
      onRender: r == null ? void 0 : r.onRender
    };
  },
  render() {
    const {
      segmented: t,
      bordered: i,
      hoverable: d,
      mergedClsPrefix: e,
      rtlEnabled: m,
      onRender: s,
      embedded: f,
      tag: a,
      $slots: r
    } = this;
    return s == null || s(), l(a, {
      class: [`${e}-card`, this.themeClass, f && `${e}-card--embedded`, {
        [`${e}-card--rtl`]: m,
        [`${e}-card--content${typeof t != "boolean" && t.content === "soft" ? "-soft" : ""}-segmented`]: t === !0 || t !== !1 && t.content,
        [`${e}-card--footer${typeof t != "boolean" && t.footer === "soft" ? "-soft" : ""}-segmented`]: t === !0 || t !== !1 && t.footer,
        [`${e}-card--action-segmented`]: t === !0 || t !== !1 && t.action,
        [`${e}-card--bordered`]: i,
        [`${e}-card--hoverable`]: d
      }],
      style: this.cssVars,
      role: this.role
    }, n(r.cover, (o) => o && l("div", {
      class: `${e}-card-cover`,
      role: "none"
    }, o)), n(r.header, (o) => o || this.title || this.closable ? l("div", {
      class: [`${e}-card-header`, this.headerClass],
      style: this.headerStyle
    }, l("div", {
      class: `${e}-card-header__main`,
      role: "heading"
    }, o || this.title), n(r["header-extra"], (c) => c && l("div", {
      class: [`${e}-card-header__extra`, this.headerExtraClass],
      style: this.headerExtraStyle
    }, c)), this.closable ? l(ee, {
      clsPrefix: e,
      class: `${e}-card-header__close`,
      onClick: this.handleCloseClick,
      absolute: !0
    }) : null) : null), n(r.default, (o) => o && l("div", {
      class: [`${e}-card__content`, this.contentClass],
      style: this.contentStyle,
      role: "none"
    }, o)), n(r.footer, (o) => o && [l("div", {
      class: [`${e}-card__footer`, this.footerClass],
      style: this.footerStyle,
      role: "none"
    }, o)]), n(r.action, (o) => o && l("div", {
      class: `${e}-card__action`,
      role: "none"
    }, o)));
  }
});
export {
  pe as cardBasePropKeys,
  p as cardBaseProps,
  te as cardProps,
  Ce as default
};
